import PropTypes from 'prop-types';
import React from 'react';

import * as Modules from './index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const ModuleDispatcher = (props) => {
    if (!props?.__typename || typeof (Modules['Module' + props?.__typename]) === 'undefined') {
        return null;
    }

    const Module = Modules['Module' + props.__typename];
    return (
        <>
            {props.borderTop && (
                <div className='border-t border-t-charcoal' />
            )}

            <Module { ...props } />

            {props.borderBottom && (
                <div className='border-b border-b-charcoal' />
            )}
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

ModuleDispatcher.propTypes = {
    __typename: PropTypes.string.isRequired,
    borderBottom: PropTypes.bool,
    borderTop: PropTypes.bool,
    isOpened: PropTypes.bool
};

export default ModuleDispatcher;
